import { breakpoints } from '@theme/breakpoints';
import styled from 'styled-components';

export default styled.div`
  display: block;
  margin-left: 20px;
  margin-right: 20px;

  @media ${breakpoints.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 1rem;
    max-width: 800px;
  }

  [class*='StyledCheckoutFormRow'] {
    font-weight: 300;
    font-size: 0.9rem;
    width: 390px;

    input {
      background-color: white;
    }
  }

`;
